export default __webpack_public_path__ + "static/square-cf23cdb30d4acb41a3772b1e1ddd720b.png";